/**
 * @generated SignedSource<<e7afc376280c4ed8836e980c6278bb31>>
 * @relayHash 3cc37d35db2639d6801e6f9136a9606b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/543.0.0-2026-01-22T17:55:48.559Z/refetchProfileDraftsTabQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type refetchProfileDraftsTabQuery$variables = {
  draftsCursor?: string | null;
  draftsFirst?: number | null;
  fetchDrafts: boolean;
  username?: string | null;
  walletAddress?: string | null;
};
export type refetchProfileDraftsTabQuery$data = {
  readonly viewer: {
    readonly collection: {
      readonly totalResults: number | null;
    } | null;
    readonly creations: {
      readonly totalResults: number | null;
    } | null;
    readonly draftItems?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftItemDraftsByCreatorEdge";
      } | null> | null;
    } | null;
    readonly liveAuctions: {
      readonly totalResults: number | null;
    } | null;
    readonly liveBids: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftAuctionsByBidderEdge";
      } | null> | null;
    } | null;
    readonly lostBids: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftAuctionsByBidderEdge";
      } | null> | null;
    } | null;
    readonly tokenImports: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"importCollectionsConfig_contractImport">;
        } | null;
      } | null> | null;
      readonly totalResults: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionDrafts_viewer">;
  };
};
export type refetchProfileDraftsTabQuery = {
  response: refetchProfileDraftsTabQuery$data;
  variables: refetchProfileDraftsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "draftsCursor"
},
v1 = {
  "defaultValue": 8,
  "kind": "LocalArgument",
  "name": "draftsFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchDrafts"
},
v3 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "username"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "walletAddress"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": "creations",
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "creatorAddresses.0",
          "variableName": "walletAddress"
        }
      ],
      "kind": "ListValue",
      "name": "creatorAddresses"
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "creatorProfileUsernames.0",
          "variableName": "username"
        }
      ],
      "kind": "ListValue",
      "name": "creatorProfileUsernames"
    },
    {
      "kind": "Literal",
      "name": "onlyFirstdibsContracts",
      "value": true
    }
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v9 = {
  "alias": "collection",
  "args": [
    (v8/*: any*/),
    {
      "items": [
        {
          "kind": "Variable",
          "name": "ownerAddresses.0",
          "variableName": "walletAddress"
        }
      ],
      "kind": "ListValue",
      "name": "ownerAddresses"
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "ownerProfileUsernames.0",
          "variableName": "username"
        }
      ],
      "kind": "ListValue",
      "name": "ownerProfileUsernames"
    }
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": "liveAuctions",
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "auctionSellerAddresses.0",
          "variableName": "walletAddress"
        }
      ],
      "kind": "ListValue",
      "name": "auctionSellerAddresses"
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "auctionSellerProfileUsernames.0",
          "variableName": "username"
        }
      ],
      "kind": "ListValue",
      "name": "auctionSellerProfileUsernames"
    },
    (v8/*: any*/)
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v11 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v12 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v14/*: any*/),
    "storageKey": null
  }
],
v16 = {
  "alias": "liveBids",
  "args": [
    (v11/*: any*/),
    {
      "kind": "Literal",
      "name": "status",
      "value": "BIDDER_LIVE"
    },
    (v12/*: any*/)
  ],
  "concreteType": "NftAuctionsByBidderConnection",
  "kind": "LinkedField",
  "name": "nftAuctionsByBidder",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": "lostBids",
  "args": [
    (v11/*: any*/),
    {
      "kind": "Literal",
      "name": "status",
      "value": "BIDDER_LOST"
    },
    (v12/*: any*/)
  ],
  "concreteType": "NftAuctionsByBidderConnection",
  "kind": "LinkedField",
  "name": "nftAuctionsByBidder",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v18 = {
  "kind": "Variable",
  "name": "creatorAddress",
  "variableName": "walletAddress"
},
v19 = [
  (v18/*: any*/),
  (v12/*: any*/)
],
v20 = {
  "condition": "fetchDrafts",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "draftItems",
      "args": (v19/*: any*/),
      "concreteType": "NftItemDraftsByCreatorConnection",
      "kind": "LinkedField",
      "name": "nftItemDraftsByCreator",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NftItemDraftsByCreatorEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importStatus",
  "storageKey": null
},
v23 = {
  "alias": "errored",
  "args": [
    {
      "kind": "Literal",
      "name": "importStatuses",
      "value": [
        "NFT_ITEM_IMPORT_STATUS_ERROR"
      ]
    }
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
},
v24 = {
  "alias": "processing",
  "args": [
    {
      "kind": "Literal",
      "name": "importStatuses",
      "value": [
        "NFT_ITEM_IMPORT_STATUS_PROCESSING"
      ]
    }
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
},
v25 = {
  "alias": "completed",
  "args": [
    {
      "kind": "Literal",
      "name": "importStatuses",
      "value": [
        "NFT_ITEM_IMPORT_STATUS_COMPLETE"
      ]
    }
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
},
v26 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "draftsCursor"
  },
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "draftsFirst"
  },
  (v12/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "refetchProfileDraftsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileSectionDrafts_viewer"
          },
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v20/*: any*/),
          {
            "alias": "tokenImports",
            "args": (v19/*: any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "importCollectionsConfig_contractImport",
                        "selections": [
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "refetchProfileDraftsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "drafts",
            "args": (v26/*: any*/),
            "concreteType": "NftItemDraftsByCreatorConnection",
            "kind": "LinkedField",
            "name": "nftItemDraftsByCreator",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItemDraftsByCreatorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraft",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "editionNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "editionTotal",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftMedia",
                        "kind": "LinkedField",
                        "name": "mainMedia",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoThumbUrl",
                            "storageKey": null
                          },
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftMedia",
                        "kind": "LinkedField",
                        "name": "posterFrameMedia",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayUrl",
                            "storageKey": null
                          },
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "modifiedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "ethereumWalletAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "publicProfileUrl",
                                "storageKey": null
                              },
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PublicProfile",
                                "kind": "LinkedField",
                                "name": "publicProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "profileName",
                                    "storageKey": null
                                  },
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v29/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v29/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "drafts",
            "args": (v26/*: any*/),
            "filters": [
              "username",
              "creatorAddress"
            ],
            "handle": "connection",
            "key": "NftProfileSectionDrafts_drafts",
            "kind": "LinkedHandle",
            "name": "nftItemDraftsByCreator"
          },
          (v29/*: any*/),
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          (v7/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v20/*: any*/),
          {
            "alias": "tokenImports",
            "args": (v19/*: any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/543.0.0-2026-01-22T17:55:48.559Z/refetchProfileDraftsTabQuery",
    "metadata": {},
    "name": "refetchProfileDraftsTabQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f7997012a098cf12f32c76fa76e34c5f";

export default node;
